const Segment = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "segment": "قطاع",

    // ERROR
    "error_name": "أدخل الاسم",
    "error_desc": "أدخل الوصف",
    "error_status": "اختر الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_status": "الحالة",
}

export default Segment;